// Third Party
import * as $ from "jquery";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Third Party libraries
const VueGallerySlideshow = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ "vue-gallery-slideshow");

const VueLightboxAdvanced = () =>
    import(/* webpackPrefetch: true, webpackChunkName: "vue-lightbox-advanced"*/ "vue-lightbox-advanced");

export default {
    name: "ModalViewProductDetails",
    mixins: [toastMessageMixins],
    components: {
        VueGallerySlideshow,
        VueLightboxAdvanced,
    },
    data() {
        return {
            product: {},
            isAPILoading: false,

            // gallery
            galleryImages: [],
            secondaryImages: [],
            primaryImageIndex: null,
            imageGalleryIndex: null,
        };
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        show(product) {
            if (!product || !Object.keys(product).length) {
                return;
            }

            if (product.productImages && product.productImages.length) {
                this.secondaryImages = product.productImages.filter((imageData) => !imageData.primary);

                this.galleryImages = product.productImages.map((img) => img.imageUrl);
                this.primaryImageIndex = product.productImages.findIndex((img) => img.primary) || 0;
            }

            this.product = product;

            $(this.$refs.modalViewProductDetails).modal("show");
        },
        hideModal() {
            $(this.$refs.modalViewProductDetails).modal("hide");
        },
        getPrimaryImage(src) {
            return src ? src : require("@/assets/images/product/dog-default-picture-color.png");
        },
        replaceWithImagePlaceholder(event) {
            event.target.src = require("@/assets/images/product/dog-default-picture-color.png");
        },
        formatPrice(price) {
            return price ? parseFloat(price).toFixed(2) : price;
        },
        onClicked(idx) {
            this.imageGalleryIndex = idx;
        },
        replacePetName(description) {
            if (!description) {
                return description;
            }

            if (this.product.petName) {
                const petName = this.product.petName;
                const capitalizedPetName = petName.charAt(0).toUpperCase() + petName.slice(1).toLowerCase();

                return description.replace(new RegExp("PET_NAME", "gi"), capitalizedPetName);
            }

            return description.replace(new RegExp("PET_NAME", "gi"), "your dog");
        },
        addToCart(productToAdd) {
            const cartItems = this.$store.getters.getPublicCartItems || [];
            const existingBundleIdIndex = cartItems.findIndex((product) => product.bundleId === productToAdd.bundleId);

            if (existingBundleIdIndex > -1) {
                this.showCustomErrorToast("Unable to add product.", "This product already exists in your cart.");
                return;
            }

            this.showCustomSuccessToast("Success!", "Product has been added to cart.");
            this.$store.dispatch("addToPublicCart", productToAdd);
        },
    },
};
